import useFlag from './useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Hook to check if the price calculation enhancements feature is enabled.
 * Moved from react-hooks to break circular dependency.
 *
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-06-10T09:53:38-0700.
 */
export function usePriceCalculationEnhancementsEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.PriceCalculationEnhancements,
    false
  );

  return Boolean(isEnabled);
}
